"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"
import Link from "next/link"
import { cn } from "@/lib/utils"
import { postCollectModalOpened } from "../../tracking"
import { Blog } from "@types"

export function PostCardCollectButton({
  postId,
  blog,
  className,
  variant,
  size,
}: {
  blog: Pick<Blog, "custom_domain" | "lowercase_url">
  postId: string
  className?: string
  variant?: "secondary" | "default"
  size?: "sm" | "lg" | "default"
}) {
  return (
    /**
     * Note: this needs to be a Paragraph link, NOT a custom domain link.
     *
     * Intercepting routes and our middleware get messed up if we use the custom domain link here.
     */
    <Link
      passHref
      // Don't use customDomainOrRelativeUrl here, as if we're in-frame,
      // we want to serve it from the paragraph.com domain.
      href={`/${blog.lowercase_url}/nft/${postId}`}
      prefetch={true}
    >
      <Button
        variant={variant || "secondary"}
        size={size || "default"}
        className={cn("font-sans", className)}
        onClick={() => postCollectModalOpened(postId)}
      >
        Collect
      </Button>
    </Link>
  )
}
